import { render, staticRenderFns } from "./Funeral.vue?vue&type=template&id=3f0b5e27&scoped=true"
import script from "./Funeral.vue?vue&type=script&lang=js"
export * from "./Funeral.vue?vue&type=script&lang=js"
import style0 from "./Funeral.vue?vue&type=style&index=0&id=3f0b5e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0b5e27",
  null
  
)

export default component.exports